import { WSAPIConstructor } from '@knitiv/api-client-javascript';
import ChatConstants from '~/pages/chat/chat.constant';
import ChatService from '../chat.service';
import WebsocketService from '../../../services/websocket.service';

export default class {
	/* @ngInject */
	/**
	 *
	 * @param {ChatService} chatService
	 * @param {Knitiv.RootScope} $rootScope
	 */
	constructor(
		chatService,
		$rootScope,
	) {
		this.chatStatuses = ChatConstants.socketStatuses;
		this.chatURL = ChatConstants.chatURL;
		this.chat = chatService;
		this.WebsocketService = WebsocketService;
		this.showHeader = $rootScope.showHeader;
		this.oldChatStatus = this.chat.status;
		this.disabled = false;

		$rootScope.$on('socket:ready', (/** @type {any} */ event, /** @type {WSAPIConstructor} */ socket) => {
			socket.getWs()?.addEventListener('message', message => {
				if (message.data === 'error') {
					this.disabled = false;
				}
			});
		});
	}

	$doCheck() {
		if (this.oldChatStatus !== this.chat.status) {
			this.oldChatStatus = this.chat.status;

			this.tooltip = this.chat.status === 'online' ? 'Chat' : 'Chat: Clicker pour tenter une connexion';
		}
	}

	reconnect() {
		this.disabled = true;
		this.WebsocketService.registerSocket();
	}
}
